// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"008c3682f5d717f26c36","655":"e652c1e0f7ebf3de81ec"}[chunkId] + ".js";
};